import styles from './PinChatButton.module.scss';
import { useObservable } from '@app/base';
import { Icon } from '@app/ui';
import { GLOBAL_CHAT_OPEN_OBSERVABLE, toggleGlobalChatOpen } from '@app/chat/utils';
import { useUserContextSelector } from '@app/main/utils';
import { Button, Tooltip } from 'antd';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

interface Props {
  chatId: string;
}

export function PinChatButton(props: Props) {
  const { chatId } = props;
  const { t } = useTranslation(undefined, { keyPrefix: 'chats' });
  const [pinedChatId] = useObservable(GLOBAL_CHAT_OPEN_OBSERVABLE);
  const userId = useUserContextSelector((x) => x.id);

  const pinActionKey = chatId === pinedChatId ? 'unpinChat' : 'pinChat';

  return (
    <Tooltip title={t(`tooltips.${pinActionKey}`)}>
      <Button
        className={classNames(styles.button, {
          [styles.pined]: chatId === pinedChatId,
        })}
        type="link"
        icon={<Icon type="pin" />}
        aria-label={t(pinActionKey)}
        onClick={() => {
          toggleGlobalChatOpen(chatId, userId);
        }}
      />
    </Tooltip>
  );
}
